import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { ProfilePillBar } from '@/components/layout/ProfilePillBar'

export function ProfileLayout() {
  const location = useLocation()
  if (location.pathname === '/profile') return <Navigate to="/profile/personal" replace />
  return (
    <div>
      <ProfilePillBar />
      <Outlet />
    </div>
  )
}
